/**
 * SEO H1 Tag Cleaner
 * Automatically converts duplicate body <h1> tags to <h2> and removes empty <h1> tags.
 */
(function () {
  function cleanDuplicateH1s() {
    try {
      const mainContent = document.getElementById('MainContent') || document.body;
      const currentPath = window.location.pathname;

      // 1. Remove empty/blank <h1> tags inside main content
      const h1Elements = Array.from(mainContent.querySelectorAll('h1'));
      h1Elements.forEach((h1) => {
        const text = h1.textContent.trim();
        const html = h1.innerHTML.trim().toLowerCase();
        if (text === '' || html === '<br>' || html === '<br/>' || html === '<br></br>') {
          if (h1.parentNode) h1.remove();
        }
      });

      // 2. Cabin Air Filter FAQs page: replace body <h1> with <h2>
      if (currentPath.includes('/pages/cabin-air-filter-faqs')) {
        const cabinH1s = Array.from(mainContent.querySelectorAll('h1'));
        cabinH1s.forEach((h1, index) => {
          // Keep the main page title h1 (first one), convert any secondary body h1 to h2
          const text = h1.textContent.toLowerCase();
          if (index > 0 || text.includes('why is it important to service my cabin filter') || text.includes('what is a cabin filter')) {
            const h2 = document.createElement('h2');
            h2.innerHTML = h1.innerHTML;
            h2.className = h1.className;
            Array.from(h1.attributes).forEach((attr) => {
              h2.setAttribute(attr.name, attr.value);
            });
            if (h1.parentNode) {
              h1.parentNode.replaceChild(h2, h1);
            }
          }
        });
      }

      // 3. Order Status & Tracking page: remove duplicate title (h1 / h2 / page-title) on /pages/order-status-tracking
      if (currentPath.includes('/pages/order-status-tracking')) {
        const mainTitle = mainContent.querySelector('.section-main-page h1, .b-main-title');
        const mainTitleText = mainTitle ? mainTitle.textContent.trim().toLowerCase() : '';
        const bodyHeadings = Array.from(mainContent.querySelectorAll('.rte h1, .rte h2, .rte .page-title, .section-text h1, .section-text h2, .section-text .page-title, h1.page-title, h2.page-title'));
        bodyHeadings.forEach((heading) => {
          if (heading !== mainTitle) {
            const text = heading.textContent.trim().toLowerCase();
            if (text === 'order status & tracking' || text === 'estado y seguimiento del pedido' || (mainTitleText && text === mainTitleText)) {
              if (heading.parentNode) heading.remove();
            }
          }
        });
        const orderH1s = Array.from(mainContent.querySelectorAll('h1'));
        if (orderH1s.length > 1) {
          for (let i = 1; i < orderH1s.length; i++) {
            if (orderH1s[i].parentNode) orderH1s[i].remove();
          }
        }
      }

      // 4. Product pages: convert any secondary <h1> in product description / RTE to <h2>
      if (currentPath.includes('/products/')) {
        const mainTitle = mainContent.querySelector('.section-main-product h1, [data-product-title-id]');
        const prodH1s = Array.from(mainContent.querySelectorAll('h1'));
        prodH1s.forEach((h1) => {
          if (h1 !== mainTitle && (h1.closest('.product__description') || h1.closest('.rte'))) {
            const text = h1.textContent.trim();
            const html = h1.innerHTML.trim().toLowerCase();
            if (text === '' || html === '<br>' || html === '<br/>') {
              if (h1.parentNode) h1.remove();
            } else {
              const h2 = document.createElement('h2');
              h2.innerHTML = h1.innerHTML;
              h2.className = h1.className;
              Array.from(h1.attributes).forEach((attr) => {
                h2.setAttribute(attr.name, attr.value);
              });
              if (h1.parentNode) {
                h1.parentNode.replaceChild(h2, h1);
              }
            }
          }
        });
      }
    } catch (error) {
      // Fail silently to guarantee no disruption
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanDuplicateH1s);
  } else {
    cleanDuplicateH1s();
  }
})();
